export * from "./RenderComponent";
import "./StringExtensions/StringExtensions";
import { TimePeriodPicker, TimePeriodPickerDefaultConfig } from "sb-resp-ui";
export var Components = {
    TimePeriodPicker: TimePeriodPicker
};
export var ComponentsProps = {
    TimePeriodPicker: TimePeriodPickerDefaultConfig
};
//# sourceMappingURL=index.js.map